import { useCountUp } from '../../hooks/useCountUp';
import { useSettings } from '../../lib/settings';
import { StaggerGroup, staggerItem } from '../ui/Reveal';
import { motion } from 'framer-motion';

export function StatsBand() {
  const settings = useSettings();
  const responseHours = settings.stat_response_hours || 48;

  const response = useCountUp(responseHours);
  const certified = useCountUp(100);
  const atHome = useCountUp(80);

  const tiles = [
    {
      key: 'one',
      value: <span>1:1</span>,
      label: 'One specialist',
      caption: 'Matched to you, never auctioned to five companies.',
    },
    {
      key: 'response',
      value: (
        <>
          <span ref={response.ref}>{response.value}</span>
          <span className="text-plum/70">hrs</span>
        </>
      ),
      label: 'Typical response',
      caption: 'A certified specialist reaches out fast, we know the clock is ticking.',
    },
    {
      key: 'certified',
      value: (
        <>
          <span ref={certified.ref}>{certified.value}</span>
          <span className="text-plum/70">%</span>
        </>
      ),
      label: 'CAPS-certified',
      caption: 'Every specialist holds the accessibility credential. No exceptions.',
    },
    {
      key: 'home',
      value: (
        <>
          <span ref={atHome.ref}>{atHome.value}</span>
          <span className="text-plum/70">%</span>
        </>
      ),
      label: 'Happen at home',
      caption: 'Most senior falls happen in the bathroom. That is where we start.',
    },
  ];

  return (
    <section className="relative py-20 sm:py-28">
      <div className="container-rosa">
        <div className="relative overflow-hidden rounded-[2rem] bg-blush bg-gradient-to-br from-terracotta/8 via-blush to-sage/8 p-8 shadow-soft ring-1 ring-stone sm:p-12 lg:p-16">
          {/* Warm ambient glow */}
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-terracotta/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-20 h-72 w-72 rounded-full bg-sage/10 blur-3xl" />

          <StaggerGroup className="relative grid grid-cols-2 gap-x-8 gap-y-10 lg:grid-cols-4">
            {tiles.map((t) => (
              <motion.div key={t.key} variants={staggerItem} className="text-center sm:text-left">
                <p className="font-display text-4xl font-bold leading-none tracking-[-0.01em] text-plum sm:text-5xl">
                  {t.value}
                </p>
                <p className="mt-2 font-body text-sm font-semibold uppercase tracking-wide text-terracotta">
                  {t.label}
                </p>
                <p className="mt-2 font-body text-sm leading-relaxed text-plum/60">{t.caption}</p>
              </motion.div>
            ))}
          </StaggerGroup>
        </div>
      </div>
    </section>
  );
}
